export default {
  name: 'Sphere',
  icon: 'mdi-radius-outline',
  label: 'Sphere',
  showInMenu() {
    return false;
  },
};
